import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from './guards/auth.guard';
import {HomeGuard} from './guards/home.guard';
import {HomeComponent} from './home/home.component';
import {environment} from '#env';
import {TermsComponent} from '@app/pages/terms/terms.component';
import {PasswordResetComponent} from '@app/pages/password-reset/password-reset.component';
import {HelpComponent} from './help/help.component';
import {HelpArticleComponent} from './help/help-article/help-article.component';
import {AccessDeniedComponent} from './access-denied/access-denied.component';
import { KnowledgeComponent } from './pages/help-center/knowledge.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [HomeGuard],
    component: HomeComponent
  },
  {
    path: 'pages',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  // {
  //   path: 'help',
  //   canActivate: [AuthGuard],
  //   canActivateChild: [AuthGuard],
  //   children: [
  //     {
  //       path: '',
  //       component: HelpComponent
  //     },
  //     {
  //       path: ':category',
  //       component: HelpComponent
  //     },
  //     {
  //       path: ':category/:slug',
  //       component: HelpArticleComponent
  //     }
  //   ]
  // },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  // {
  //   path: 'terms',
  //   component: TermsComponent
  // },
  {
    path: 'password-reset',
    component: PasswordResetComponent
  },
  // {
  //   path: 'help',
  //   component: HelpComponent
  // },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'help-center',
    loadChildren: () => import('./pages/help-center/help-center.module').then(m => m.HelpCenterModule)
  },
  {
    path: './help-center/:categoryslug/:helpslug',
    component: KnowledgeComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      enableTracing: !environment.production,
      initialNavigation: 'enabled'
    }
  )],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
